import React from "react";
import Icon from "../atoms/Icon";
import { Link } from "../Router";

export default ({ className, isRound, isRed, onClick }) =>
    <Link className={ "m-logo" + (isRound ? " m-logo--round" : "") } to="/" onClick={ onClick }>
        <Icon
            className={ "m-logo__icon a-icon" + (isRed ? " m-logo__icon--dark" : "") + (className || "") }
            iconName="lapoint-logo"
        />
        <span className="u-visually-hidden">Lapoint logo</span>
    </Link>;
